var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealAproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4532 17.8801L17.8932 27.4401C17.6455 27.688 17.3514 27.8847 17.0277 28.0189C16.704 28.1531 16.3569 28.2222 16.0065 28.2222C15.6561 28.2222 15.3091 28.1531 14.9853 28.0189C14.6616 27.8847 14.3675 27.688 14.1198 27.4401L2.6665 16.0001V2.66675H15.9998L27.4532 14.1201C27.9498 14.6197 28.2286 15.2956 28.2286 16.0001C28.2286 16.7046 27.9498 17.3804 27.4532 17.8801V17.8801Z",
    stroke: "#DE4842",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 9.33325H9.34683",
    stroke: "#DE4842",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealAproval);
export default __webpack_public_path__ + "static/media/deal-aproval.415b6caa.svg";
export { ForwardRef as ReactComponent };